export class Caracteristica {
  codigoCaracteristica: string;
  caracteristicaObrigatoria: boolean;
  numeroCaracteristica: number;
  nomeCaracteristica: string;
  siglaUnidadeMedida: any;
  valorCaracteristica: any;
  statusCaracteristica: any;
}
